/*
key statsV1
value statsV2
*/
export const statsTypeMap = {
    games_played: "matches_played",
    mins_played: "normalized_player_minutes",
    total_sub_on: "substitutions_in",
    accurate_pass_per: "passes_from_play_conversion_rate",
    total_scoring_att: "shots_at_goal_sum",
    ontarget_scoring_att: "shots_on_target",
    key_passes: "assists_shot_at_goal_sum",
    expected_goals: "xg",
    fk_foul_won: "fouls_sum",
    fk_foul_lost: "fouls_suffered",
    total_offside: "offsides",
    yellow_card: "cards_yellow",
    total_red_card: "cards_red",
    interceptions: "interceptions_sum",
    interception: "interceptions_sum",
    att_freekick_total: "passes_and_crosses_from_standards_sum",
    accurate_cross: "crosses_successful_sum",
    total_att_assist: "assists_shot_at_goal",
    red_card: "cards_red",
    penalty_faced: "penalties_saved",
    att_pen_taken: "penalties_successful",
    total_pass: "passes_sum",
    att_lf_total: "shots_at_goal_left_leg",
    substitution_in: "substitutions_in",
    total_clearance: "defensive_clearances",
    successful_short_pass: "passes_from_open_play_short_successful_ratio",
    accurate_back_zone_pass: "",
    accurate_fwd_zone_pass: "",
    att_rf_total: "shots_at_goal_right_leg",
    appearances: "matches_played",
    game_started: "",
    accurate_long_balls: "passes_from_open_play_long",
    penalty_save: "penalties_saved",
    att_pen_goal: "penalties_successful",
    total_clearance: "defensive_clearances",
    att_hd_total: "shots_at_goal_head",
    aerial_duel: "tackling_games_air_sum",
    aerial_duel_per: "",
    shots: "shots_at_goal_sum",
    clean_sheet: "clean_sheets",

    // clubs
    corner_taken: "corner_kicks_sum",
    accurate_pass: "passes_successful_sum",
    expected_goals: "xG",
    expected_assists: "passes_conversion_rate",
    key_passes: "goal_opportunities",
    goal_assist: "first_and_second_assists",
    total_matches: "",
    completed_passes: "passes_successful_sum",
    saves: "goalkeeper_saves"
}